module.exports = __webpack_public_path__ + "static/media/image-slider.7127961b.png";